import { createOrganization } from "../../../../api/application/organization";
import Navbar from "../../parts/Navbar/Navbar";
import OrganizationForm from "../OrganizationForm";
import "./index.scss";

export default function OrganizationCreatePage() {
  return (
    <div className="OrganizationCreatePage">
      <Navbar pageTitle="Créer une organisation" />

      <div className="OrganizationCreatePage-content Container">
        <OrganizationForm submitBtnLabel="Créer la structure" onSubmit={createOrganization} />
      </div>
    </div>
  );
}
